import { render, staticRenderFns } from "./NewOption.vue?vue&type=template&id=79150b0d"
import script from "./NewOption.vue?vue&type=script&lang=js"
export * from "./NewOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports